module.exports = __webpack_public_path__ + "img/nouvelleNoir-min.6bf03345.png";